let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("frDmN")).then(() => parcelRequire('Wr6a5'));